
import React from 'react';

/**
 *
 * Main MySofology Logo SVG
 *
 * @param { string } textColor css class corresponds to a .my-sofology-logo color class
 *
 */
function MySofologyLogo({ textColor = 'white' }) {
  return (
    <svg
      className="my-sofology-logo"
      id="Layer_1"
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 2122 472.5"
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">
        My Sofology
      </title>
      <desc id="desc">
        My Sofology logo, the words my sofology with the sofology logo in the top left corner
      </desc>
      <g className="pink">
        <path d="M265.7,71.5c0,1.7-1.4,3.1-3.1,3.1h-47c-1.7,0-3.1-1.4-3.1-3.1v-47c0-1.7,1.4-3,3.1-3h47c1.7,0,3.1,1.4,3.1,3
        V71.5L265.7,71.5z"
        />
        <path d="M212.6,124.6c0,1.7-1.4,3.1-3.1,3.1h-47c-1.7,0-3.1-1.4-3.1-3.1v-47c0-1.7,1.4-3.1,3.1-3.1h47
        c1.7,0,3.1,1.4,3.1,3.1V124.6L212.6,124.6z"
        />
      </g>

      <g className="blue">
        <path d="M124.4,151.2c0,1.7-1.4,3.1-3.1,3.1h-47c-1.7,0-3-1.4-3-3.1v-47c0-1.7,1.4-3.1,3-3.1h47c1.7,0,3.1,1.4,3.1,3.1
        V151.2L124.4,151.2z"
        />
        <path
          className="blue"
          d="M177.5,204.3c0,1.7-1.4,3.1-3.1,3.1h-47c-1.7,0-3.1-1.4-3.1-3.1v-47c0-1.7,1.4-3.1,3.1-3.1h47
        c1.7,0,3.1,1.4,3.1,3.1V204.3L177.5,204.3z"
        />
      </g>

      <g className="yellow">
        <path d="M246.8,204.3c0,1.7-1.4,3.1-3.1,3.1h-47c-1.7,0-3.1-1.4-3.1-3.1v-47c0-1.7,1.4-3.1,3.1-3.1h47
        c1.7,0,3.1,1.4,3.1,3.1V204.3L246.8,204.3z"
        />
        <path d="M299.9,151.2c0,1.7-1.4,3.1-3.1,3.1h-47c-1.7,0-3.1-1.4-3.1-3.1v-47c0-1.7,1.4-3.1,3.1-3.1h47
        c1.7,0,3.1,1.4,3.1,3.1V151.2L299.9,151.2z"
        />
      </g>

      <g className={textColor}>
        <path d="M304.4,387.8V228h14.4v27.2c6.3-10.2,14.9-18.1,25.8-23.7c11-5.6,22.9-8.4,35.8-8.4c32.8,0,53.2,12.4,61.3,37.1
          c11.7-24.8,32.3-37.1,62-37.1c44.4,0,66.7,18.8,66.7,56.5v108.3H556V284.2c0-14.4-4-25.8-11.9-34.3c-9-9.6-22.3-14.4-40-14.4
          c-19.4,0-34.1,4.7-44.3,14.2c-10.2,9.5-15.3,22.7-15.3,39.8v98.3h-14.4V281.4c0-30.6-17.3-45.9-51.8-45.9
          c-17.9,0-32.2,4.9-42.8,14.7c-11.2,10.2-16.9,24.4-16.9,42.5v95.2H304.4z"
        />
        <path d="M664.6,387.8L583.8,228H600l71.8,143.9L737.7,228h16.2l-88,187.9c-4.8,10-9.6,17.1-14.4,21.2
          c-6.5,5.4-15.4,8.1-26.8,8.1h-20v-12.5h17.2c9.2,0,15.7-1.7,19.5-5c3.8-3.3,8.9-11.2,15.1-23.7L664.6,387.8z"
        />
        <path d="M922.4,274.8H908c-1-13.5-6.3-23.5-15.8-29.8s-24.4-9.5-44.8-9.5c-34.8,0-52.1,10.6-52.1,31.8
          c0,15.2,10.7,24.2,32.1,27.2l50.9,6.9c33.5,4.6,50.2,19.1,50.2,43.7c0,31.8-25.5,47.8-76.5,47.8c-49.9,0-75.9-18.3-78-54.9h14.4
          c1.5,12.5,5.2,21.6,11.2,27.5c10.4,10,29.1,15,56.2,15c38.9,0,58.4-11.8,58.4-35.3c0-16.4-10.7-26.1-32.1-29l-56.2-7.5
          c-30-3.9-44.9-17.4-44.9-40.3c0-11.6,4.4-21.4,13.1-29.3c11.6-10.6,29.6-15.9,54-15.9C895.1,223,919.9,240.2,922.4,274.8
          L922.4,274.8z"
        />
        <path d="M957.6,307.9c0,19.8,6.3,36.4,19,49.9c13.9,15,32.9,22.5,56.8,22.5c23.9,0,42.9-7.5,56.8-22.5
          c12.7-13.5,19-30.2,19-49.9c0-19.8-6.3-36.4-19-49.9c-13.9-15-32.9-22.5-56.8-22.5c-23.9,0-42.9,7.5-56.8,22.5
          C964,271.5,957.6,288.1,957.6,307.9L957.6,307.9z M943.3,307.9c0-23.5,7.9-43.3,23.7-59.3c16.9-17.1,39-25.6,66.5-25.6
          s49.6,8.5,66.5,25.6c15.8,16,23.7,35.8,23.7,59.3s-7.9,43.3-23.7,59.3c-16.9,17.1-39,25.6-66.5,25.6s-49.6-8.5-66.5-25.6
          C951.2,351.1,943.3,331.4,943.3,307.9L943.3,307.9z"
        />
        <path d="M1166.1,387.8V240.5h-37.5V228h37.5v-24c0-13.7,2.6-23.7,7.8-30c6.2-7.3,17.2-10.9,32.8-10.9 c4.4,0,12.6,0.6,24.7,1.9v12.5c-6.9-1.2-14.5-1.9-22.8-1.9c-18.7,0-28.1,8-28.1,24V228h46.1v12.5h-46.2v147.3H1166.1L1166.1,387.8z" />
        <path d="M1246.6,307.9c0,19.8,6.3,36.4,19,49.9c13.9,15,32.9,22.5,56.8,22.5c23.9,0,42.9-7.5,56.8-22.5 c12.7-13.5,19-30.2,19-49.9c0-19.8-6.3-36.4-19-49.9c-13.9-15-32.9-22.5-56.8-22.5s-42.9,7.5-56.8,22.5
          C1253,271.5,1246.6,288.1,1246.6,307.9L1246.6,307.9z M1232.2,307.9c0-23.5,7.9-43.3,23.7-59.3c16.9-17.1,39-25.6,66.5-25.6
          s49.6,8.5,66.5,25.6c15.8,16,23.7,35.8,23.7,59.3s-7.9,43.3-23.7,59.3c-16.9,17.1-39,25.6-66.5,25.6s-49.6-8.5-66.5-25.6
          C1240.2,351.1,1232.2,331.4,1232.2,307.9L1232.2,307.9z"
        />
        <polygon points="1439.5,387.8 1439.5,164.9 1453.8,164.9 1453.8,387.8 " />
        <path d="M1495,307.9c0,19.8,6.3,36.4,19,49.9c13.9,15,32.9,22.5,56.8,22.5s42.9-7.5,56.8-22.5
          c12.7-13.5,19-30.2,19-49.9c0-19.8-6.3-36.4-19-49.9c-13.9-15-32.9-22.5-56.8-22.5s-42.9,7.5-56.8,22.5
          C1501.3,271.5,1495,288.1,1495,307.9L1495,307.9z M1480.7,307.9c0-23.5,7.9-43.3,23.7-59.3c16.9-17.1,39-25.6,66.5-25.6
          c27.5,0,49.6,8.5,66.5,25.6c15.8,16,23.7,35.8,23.7,59.3s-7.9,43.3-23.7,59.3c-16.9,17.1-39,25.6-66.5,25.6s-49.6-8.5-66.5-25.6
          C1488.6,351.1,1480.7,331.4,1480.7,307.9L1480.7,307.9z"
        />
        <path d="M1764.7,235.5c-20.4,0-37.2,5.4-50.6,16.2c-14.8,12.3-22.2,29.3-22.2,51.2c0,22.7,6.4,40.1,19.3,52.3
          c12.9,12.2,31.2,18.3,54.9,18.3c21.8,0,39.3-5.7,52.4-17.2c14.1-12.5,21.2-30.4,21.2-53.7c0-21-6.7-37.5-20-49.3
          C1806.6,241.4,1788.2,235.5,1764.7,235.5L1764.7,235.5z M1839.9,260.4V228h14.4v152c0,51-29.1,76.5-87.4,76.5
          c-25.6,0-44.9-4.1-58.1-12.2c-13.9-8.5-22.2-22.4-24.7-41.5h14.4c3.7,27.5,26.5,41.2,68.3,41.2c48.7,0,73-21.1,73-63.4v-33.1h-0.6
          c-13.5,25.6-38.5,38.4-74.9,38.4c-29.1,0-51.4-8.4-66.8-25.3c-13.3-14.6-20-33.6-20-57.1c0-22.7,6.9-41.3,20.6-55.9
          c15.6-16.4,37.8-24.7,66.5-24.7c36.8,0,61.7,12.4,74.6,37.1L1839.9,260.4L1839.9,260.4z"
        />
        <path d="M1948.2,387.8L1867.4,228h16.2l71.8,143.9l65.9-143.9h16.2l-88,187.9c-4.8,10-9.6,17.1-14.4,21.2
          c-6.4,5.4-15.4,8.1-26.8,8.1h-20v-12.5h17.2c9.1,0,15.6-1.7,19.5-5c3.8-3.3,8.9-11.2,15.1-23.7L1948.2,387.8L1948.2,387.8z"
        />
      </g>

      <g>
        <path
          className="blue"
          d="M1223.3,438.2c0,3.8-3.4,6.9-7.5,6.9h-187.6c-4.1,0-7.5-3.1-7.5-6.9s3.4-6.9,7.5-6.9h187.6
          C1220,431.3,1223.3,434.4,1223.3,438.2"
        />
        <path
          className="pink"
          d="M1436.6,438.2c0,3.8-3.4,6.9-7.5,6.9h-187.6c-4.1,0-7.5-3.1-7.5-6.9s3.4-6.9,7.5-6.9h187.6
          C1433.2,431.3,1436.6,434.4,1436.6,438.2"
        />
        <path
          className="yellow"
          d="M1649.7,438.2c0,3.8-3.4,6.9-7.5,6.9h-187.5c-4.1,0-7.5-3.1-7.5-6.9s3.4-6.9,7.5-6.9h187.6
          C1646.4,431.3,1649.7,434.4,1649.7,438.2"
        />
      </g>

      <g className="grey">
        <circle
          fill="none"
          stroke="#808285"
          r="33"
          cy="162"
          cx="2070"
          strokeWidth="3px"
        />
        <path d="M2060.9,149.7V161h13.4c4.4,0,6.6-2,6.6-6c0-3.6-2.1-5.4-6.3-5.4L2060.9,149.7L2060.9,149.7z M2057.6,177.4
          v-30.6h16.7c6.6,0,9.9,2.8,9.9,8.3c0,1.7-0.5,3.2-1.5,4.6c-1.1,1.5-2.6,2.4-4.5,2.8v0.1c2,0.3,3.4,1.2,4.2,2.6
          c0.7,1.2,1.1,3.2,1.2,5.9c0.2,3.7,0.5,5.8,1.1,6.3h-3.4c-0.5-0.6-0.8-2.7-0.8-6.2c0-2.7-0.6-4.6-1.7-5.6c-1.1-1.1-3-1.6-5.7-1.6
          h-12.3v13.4H2057.6L2057.6,177.4z"
        />
      </g>

    </svg>

  );
}

export default MySofologyLogo;



// WEBPACK FOOTER //
// ./src/layout/graphics/MySofologyLogo.js